










import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'PageSpinner',
})
export default class PageSpinner extends Vue {
}
